module.exports = __webpack_public_path__ + "img/plus_00.0085a69e.png";